<template>
    <teleport to="#flash-target">
        <transition>
            <div class="top-flash" :class="[flashStore.flash.type, {timeout: flashStore.flash.timeout}]" v-if="flashStore.flash" :style="{'--s': width}" @mouseenter="pause" @mouseleave="release">
                <div class="content">
                    <div class="icon centered-thing" v-if="flashStore.flash.icon || icon">
                        <fa-icon :icon="flashStore.flash.icon ?? icon"></fa-icon>
                    </div>
                    <div class="message">{{ flashStore.flash.message }} </div>
                    <div class="close-btn centered-thing" @click.capture.stop="flashStore.closeFlash()">&times;</div>
                </div>
            </div>
        </transition>
    </teleport>
</template>

<script lang="ts" setup>
import { useFlashStore } from '~~/store/flashStore';
import anime from 'animejs/lib/anime.es.js';


const flashStore = useFlashStore();

const width = ref('0%');

let animation: anime.AnimeInstance | null = null;

function stopAnimation() {
    if (animation) {
        animation.pause();
        animation = null;
    }
}

function pause() {
    if (!animation) {
        return;
    }

    animation.restart();
    animation.pause();
}

function release() {
    if (animation) {
        animation.play();
    }
}

function setupTimeout() {
    animation = anime({
        targets: width,
        value: ['100%', '0%'],
        easing: 'linear',
        duration: flashStore.flash!.timeout!,
        complete: () => {
            flashStore.closeFlash();
        }
    });
}

watch(() => flashStore.flash, () => {
    stopAnimation();

    if (flashStore.flash?.timeout) {
        setupTimeout();
    }
});


const icon = computed(() => {
    switch (flashStore.flash?.type) {
        case 'error':
        case 'warning':
            return 'exclamation';
        case 'success':
            return 'check';
    }

    return null;
});

</script>

<style lang="scss" src="./style.scss" scoped>
</style>
